export default __webpack_public_path__ + "static/media/spons-box.cd74ec34.svg";